
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form/defList",
      function () {
        return require("private-next-pages/form/defList.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form/defList"])
      });
    }
  